import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.concat.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.join.js';
import toArray from './toArray.js';

function getFieldId(namePath, formName) {
  var namePaths = toArray(namePath);
  var mergedId = namePaths.join('_');
  if (formName) {
    return "".concat(formName, "_").concat(mergedId);
  }
  return mergedId;
}

export { getFieldId as default };
